import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sawyer'
})
export class SawyerPipe implements PipeTransform {

  transform(value: any): any {
    if(!value) return;
    return value.filter(inv => {
        return (inv.saw == true);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/inventory/pipes/sawyer-pipe.ts